module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.3-244.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.3.md
// module id = 688
// module chunks = 278